"use strict"
var _ = require('lodash')
var inherits = require('util').inherits
var Writable = require('stream').Writable

function LatestCounterGraph (graphOptions) {
  if (!(this instanceof LatestCounterGraph)) {
    return new LatestCounterGraph(graphOptions)
  }
  Writable.call(this, {objectMode: true})
  this.counterTypes = graphOptions.counterTypes
  this.stackBy = graphOptions.stackBy || 'none'

  this.latestValue = {
    timestamp: 0,
    value: 0
  }
}
inherits(LatestCounterGraph, Writable)

var proto = LatestCounterGraph.prototype

proto._write = function (data, enc, next) {
  this.latestValue = data
  next()
}

proto.resetHistory = function () {
  // TODO: implement this
}

proto.getGraphData = function () {
  var latestValue = this.latestValue
  var graphData = {
    timestamp: latestValue.timestamp,
    value: latestValue.value
  }

  if (this.counterTypes.length === 1) {
    graphData[this.counterTypes[0]] = graphData.value
  } else if (this.stackBy === 'type' && latestValue.values) {
    _.each(this.counterTypes, function (counterType) {
      graphData[counterType] = latestValue.values[counterType]
    })
  }

  return graphData
}

proto.destroy = function () {
  if (this.destroyed) { return }
  this.destroyed = true
}

module.exports = LatestCounterGraph
